import { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { filterHandler } from "../../services/helpers";

import { Table, Icon, Alert } from "design-react-kit";

import "../../assets/Table.css";
import secureLocalStorage from "react-secure-storage";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";

const ClientDocumentsConfigurationTable = ({
  items,
  columns,
  documentsModalOpenHandler,
  confirmModalOpenHandler,
  getClientDocumentRules,
}) => {
  const [results, setResults] = useState(null);

  const navigate = useNavigate();

  const params = useParams();
  const clientName = params?.client;
  const clientId = params?.clientId;

  useEffect(() => {
    setResults(items);
  }, [items]);

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Ricerca per documento"}
            column={"documentTypeName"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getClientDocumentRules()}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.documentType}>
                    <td className="documentName text-center">
                      {result.documentTypeName}
                    </td>
                    <td className="minOccurance text-center">
                      {result.minOccurrence}
                    </td>
                    <td className="maxOccurance text-nowrap text-center">
                      {result.maxOccurrence}
                    </td>
                    <td className="isAttached text-nowrap text-center">
                      {result.isAttached && (
                        <Icon icon="it-check" fill="#2cb61d" />
                      )}
                      {!result.isAttached && (
                        <Icon icon="it-close" fill="#d70049" />
                      )}
                    </td>
                    <td className="isAnalyzed text-nowrap text-center">
                      {result.isAnalyzed && (
                        <Icon icon="it-check" fill="#2cb61d" />
                      )}
                      {!result.isAnalyzed && (
                        <Icon icon="it-close" fill="#d70049" />
                      )}
                    </td>
                    <td className="actions text-center">
                      <span title="Configura documento" className="mr-2">
                        <Icon
                          id="edit-client"
                          icon="it-pencil"
                          fill="#06c"
                          role="button"
                          onClick={(e) => documentsModalOpenHandler(result)}
                        />
                      </span>

                      {result.isAnalyzed && (
                        <span title="Configura frasi chiave" className="mr-2">
                          <Icon
                            id="configure-phrases"
                            icon="it-behance"
                            fill="#06c"
                            role="button"
                            onClick={(e) =>
                              navigate(
                                `/clientConfiguration/clientDocumentsConfiguration/ClientDocumentPhrasesConfiguration/${clientName}/${result.clientId}/${result.documentTypeName}/${result.documentType}/${result.clientDocumentRuleId}`
                              )
                            }
                          />
                        </span>
                      )}
                      {result.isAnalyzed && (
                        <img
                          title="Analisi"
                          alt="Preview"
                          className="preview-icon mr-2 ml-2"
                          src="./preview-blue.svg"
                          onClick={(e) => {
                            secureLocalStorage.setItem(
                              "docPattern",
                              result.documentNamePattern
                            );
                            navigate(
                              `/clientConfiguration/clientDocumentsConfiguration/preview/${clientId}/${result.documentType}`
                            );
                          }}
                        />
                      )}
                      <span title="Rimuovi documento">
                        <Icon
                          id="delete-configuration"
                          icon="it-delete"
                          fill="#005A9A"
                          role="button"
                          onClick={(e) => confirmModalOpenHandler(result)}
                        />
                      </span>
                    </td>
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </Fragment>
  );
};

export default ClientDocumentsConfigurationTable;
